import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Cal, { getCalApi } from "@calcom/embed-react";
import "../styles/Contact.css";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

export default function Contact() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ "namespace": "discovery-call" });
      cal("ui", {
        "theme": "dark",
        "styles": { "branding": { "brandColor": "#64D98A" } },
        "hideEventTypeDetails": false,
        "layout": "month_view"
      });
    })();

    gsap.set(".contact-container", {
      width: "100%",
      maxWidth: "900px",
      height: "auto",
      margin: "0 auto"
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#contact",
        start: "top 80%",
        toggleActions: "play none none reverse"
      }
    });

    tl.fromTo(
      "#contact .section-title",
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" }
    );

    tl.fromTo(
      ".contact-intro",
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" },
      "-=0.4"
    );

    tl.fromTo(
      ".contact-container",
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
      "-=0.3"
    );

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section id="contact">
      <div className="section-header">
        <span className="section-title">Book a Free Discovery Call</span>
      </div>
      <div className="contact-intro">
        <p>
          Schedule a call with me to discuss your project, get a personalized quote, or ask any questions. Pick a time that works for you!
        </p>
      </div>
      <div className="contact-container">
        <div className="contact-bg-elements">
          <div className="contact-square"></div>
        </div>

        {/* Cal.com Embed */}
        <div className="cal-embed-wrapper">
          <Cal
            namespace="discovery-call"
            calLink={process.env.REACT_APP_CAL_LINK || "faizaan-fareed-yk9u1j"}
            style={{ width: "100%", height: "auto" }}
            config={{ layout: 'month_view', theme: 'dark' }}
          />
        </div>

      </div>
    </section>
  );
}